import {apiClient} from 'core/apiClient';
import {
    BlockingFormData,
    BlockingScopes,
    BlokcingReason,
    CreateBlockingDocumentPayload,
    RemoveCodeLockPayload,
} from 'types/products-blocking';

export const removeCodeLock = async (payload: RemoveCodeLockPayload) => {
    const {blockingId, markingCode, unblockingReason, comment} = payload;
    const response = await apiClient.patch(
        `/marking/blocking/${blockingId}/remove`,
        {
            unblockingReason,
            comment,
        },
        {
            params: {
                markingCode,
            },
            baseURL: '/api/v2',
        },
    );
    return response.data;
};

export const createBlockingDocument = async (params: BlockingFormData & {codes: string[]}) => {
    const {
        attachmentFiles = [],
        supportingDocumentDate,
        supportingDocumentNumber,
        comment,
        reason,
        scope,
        codes,
        documentId,
    } = params;

    const attachment = await Promise.all(
        attachmentFiles.map(async (file) => {
            const formData = new FormData();
            formData.append(
                'documentNumber',
                new Blob([JSON.stringify(documentId)], {type: 'application/json'}),
            );
            formData.append('file', file);

            return (
                await apiClient.post<{documentKey: string}>(
                    '/marking/documents/file/upload',
                    formData,
                    {baseURL: '/api/v2'},
                )
            ).data.documentKey;
        }),
    );

    const payload: CreateBlockingDocumentPayload = {
        documentId,
        codes,
        reason: reason as BlokcingReason,
        scopes: [scope as BlockingScopes],
        ...(supportingDocumentNumber?.trim()
            ? {supportingDocumentNumber: supportingDocumentNumber.trim()}
            : {}),
        ...(supportingDocumentDate
            ? {supportingDocumentDate: supportingDocumentDate.toISOString()}
            : {}),
        ...(comment?.trim() ? {comment: comment.trim()} : {}),
        ...(attachment.length ? {attachment} : {}),
    };

    const data = await apiClient.post('/marking/blocking', payload, {
        baseURL: '/api/v2',
    });

    return {data};
};
